import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

interface EyeOffIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const EyeOffIcon = ({ className, asChild = false }: EyeOffIconProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.970141 1.72749C0.710141 1.52249 0.332641 1.56999 0.127641 1.82999C-0.0773595 2.08999 -0.0298595 2.46749 0.230141 2.67249L15.0301 14.2725C15.2901 14.4775 15.6676 14.43 15.8726 14.17C16.0776 13.91 16.0301 13.5325 15.7701 13.3275L13.1401 11.2675C14.1301 10.2525 14.8001 9.11499 15.1376 8.30749C15.2201 8.10999 15.2201 7.88999 15.1376 7.69249C14.7651 6.79999 13.9826 5.49999 12.8126 4.41499C11.6376 3.31999 10.0201 2.39999 8.00014 2.39999C6.29514 2.39999 4.87514 3.05749 3.76764 3.91999L0.970141 1.72749ZM5.57764 5.33749C6.21514 4.75499 7.06764 4.39999 8.00014 4.39999C9.98764 4.39999 11.6001 6.01249 11.6001 7.99999C11.6001 8.62249 11.4426 9.20749 11.1651 9.71749L10.2001 8.96249C10.4101 8.47999 10.4651 7.92749 10.3201 7.37999C10.0426 6.34249 9.12514 5.64499 8.10514 5.60249C7.96014 5.59749 7.87514 5.75499 7.92014 5.89499C7.97264 6.05499 8.00264 6.22499 8.00264 6.40249C8.00264 6.65749 7.94264 6.89749 7.83764 7.10999L5.58014 5.33999L5.57764 5.33749ZM9.32514 11.3475C8.91514 11.51 8.46764 11.6 8.00014 11.6C6.01264 11.6 4.40014 9.98749 4.40014 7.99999C4.40014 7.82749 4.41264 7.65999 4.43514 7.49499L2.07764 5.63749C1.50764 6.37999 1.10014 7.11999 0.862641 7.69249C0.780141 7.88999 0.780141 8.10999 0.862641 8.30749C1.23514 9.19999 2.01764 10.5 3.18764 11.585C4.36264 12.68 5.98014 13.6 8.00014 13.6C9.19514 13.6 10.2476 13.2775 11.1551 12.7875L9.32514 11.3475Z"
        fill="#353C40"
      />
    </Comp>
  );
};

EyeOffIcon.displayName = "EyeOffIcon";

export { EyeOffIcon };
